import { dateStringTransformer } from "@/utils/zodTransformers";
import { z } from "zod";

export const partySchema = z.object({
    idUUID: z.string(),
    idCaseID: z.string(),
    contactName: z.string().optional().nullable(),
    claimNumber: z.string().optional().nullable(),
    idCompanyID: z.string().optional().nullable(),
    idAdjuster: z.string().optional().nullable(),
    policyPersonCoverageMM: z.string().optional().nullable(),
    policyVehiculeCoverageMM: z.string().optional().nullable(),
    policyInsuredName: z.string().optional().nullable(),
    policyDriverName: z.string().optional().nullable(),
    formLimits: z.string().optional().nullable(),
    roleName: z.string().optional().nullable(),

    companyName: z.string().optional().nullable(),
    address: z.string().optional().nullable(),
    address2: z.string().optional().nullable(),
    city: z.string().optional().nullable(),
    state: z.string().optional().nullable(),
    zip: z.string().optional().nullable(),
    providerStartDate: dateStringTransformer,
    providerEndDate: dateStringTransformer,
    providerReductionApproved: z.string().optional().nullable(),
    note: z.string().optional().nullable(),
    selectedMedia: z.string().optional().nullable(),
    selectedRecord: z.string().optional().nullable(),
    phoneNumber: z.string().optional().nullable(),
    phoneExtension: z.string().optional().nullable(),
    faxNumber: z.string().optional().nullable(),

    namePrefix: z.string().optional().nullable(),
    nameFirst: z.string().optional().nullable(),
    nameI: z.string().optional().nullable(),
    nameLast: z.string().optional().nullable(),
    nameSuffix: z.string().optional().nullable(),
    nameAKA: z.string().optional().nullable(),
    email: z.string().optional().nullable(),

    checkAmountMM: z.string().optional().nullable(),
    loanAmount: z.string().optional().nullable(),
    loanDate: dateStringTransformer,
    loanPayoffAmount: z.string().optional().nullable(),
    loanPayoffDate: dateStringTransformer,

    coverageType: z.string().optional().nullable(),
    medpay: z.string().optional().nullable(),
    idAdjusterView: z.string().optional().nullable(),

    providerBalance: z.number().optional().nullable(),
    providerBill: z.string().optional().nullable(),
    providerHealthInsPmt: z.number().optional().nullable(),
    providerSelfPay: z.number().optional().nullable(),
    providerMedPay: z.number().optional().nullable(),
    providerClientToPay: z.number().optional().nullable(),
    providerReduction: z.number().optional().nullable(),
    providerAdjustment: z.number().optional().nullable(),
});
